import { render, staticRenderFns } from "./ErrorHeader.vue?vue&type=template&id=84759dbc&scoped=true&"
import script from "./ErrorHeader.vue?vue&type=script&lang=js&"
export * from "./ErrorHeader.vue?vue&type=script&lang=js&"
import style0 from "./ErrorHeader.vue?vue&type=style&index=0&id=84759dbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84759dbc",
  null
  
)

export default component.exports